/** Default auto-refresh interval for dashboard/home widgets (seconds). */
export const DEFAULT_WIDGET_REFRESH_RATE_SECONDS = 300;

/**
 * Resolve per-widget refresh interval (seconds).
 * Supports top-level refresh_rate or nested widget_config / chart_config.
 */
export function getWidgetRefreshRateSeconds(widget) {
  const raw =
    widget?.refresh_rate ??
    widget?.widget_config?.refresh_rate ??
    widget?.chart_config?.refresh_rate;
  const n = Number(raw);
  if (Number.isFinite(n) && n > 0) return n;
  return DEFAULT_WIDGET_REFRESH_RATE_SECONDS;
}

export function hasWidgetCachedDataset(widget) {
  const ds = widget?.dataset;
  return !!(ds && typeof ds === 'object' && Object.keys(ds).length > 0);
}

/**
 * Milliseconds since refresh_datetime, or null when timestamp is missing/invalid.
 */
export function getWidgetCacheAgeMs(widget, nowMs = Date.now()) {
  const refreshedAt = widget?.refresh_datetime;
  if (!refreshedAt) return null;
  const t = new Date(refreshedAt).getTime();
  if (!Number.isFinite(t)) return null;
  return nowMs - t;
}

/**
 * True when there is no usable cache, or refresh_datetime is older than refresh_rate.
 * Widgets with a dataset but no refresh_datetime are treated as fresh (legacy rows).
 */
export function isWidgetCacheExpired(widget, nowMs = Date.now()) {
  if (!hasWidgetCachedDataset(widget)) return true;
  const ageMs = getWidgetCacheAgeMs(widget, nowMs);
  if (ageMs == null) return false;
  const ttlMs = getWidgetRefreshRateSeconds(widget) * 1000;
  return ageMs >= ttlMs;
}
